import React, { PropTypes, Component } from 'react';
import moment from 'moment/min/moment.min';

import './styles.scss';

function getLocaled(m) {
  return m.calendar(null, {
    lastDay: '[Yesterday]',
    sameDay: '[Today]',
    nextDay: '[Tomorrow]',
    lastWeek: '[last] dddd',
    nextWeek: 'dddd',
    sameElse: 'L',
  });
}

/**
 * Helper: gets the start and finish time the shift card is meant to display
 *
 * @param  {String} type the type of clock (eg. in or out).
 * @param  {type} user the current user of the time clock.
 * @return {Object} return the date, start, finish + shift & teams details for current/next shift.
 */
export class ShiftCard extends Component {
  buildTimes() {
    const { schedule: { start, finish } } = this.props;

    if (!start || !finish) {
      return {};
    }

    const startMoment = moment(start * 1000);
    const finishMoment = moment(finish * 1000);

    return {
      startTime: startMoment.isValid() ? startMoment.format('h:mm a') : '--:--',
      startDate: startMoment.isValid() ? getLocaled(startMoment) : '',
      finishTime: finishMoment.isValid() ? finishMoment.format('h:mm a') : '--:--',
      finishDate: finishMoment.isValid() ? getLocaled(finishMoment) : '',
    };
  }

  validShift() {
    const { schedule, team } = this.props;
    return (schedule.start && schedule.finish && team.name && team.colour);
  }

  render() {
    /** @type {Object} args the props needed to collate the shift card information */
    const { team, shiftDetail } = this.props;

    const times = this.buildTimes();

    if (this.validShift()) {
      return (
        <div className='ShiftCard'>
          <div className='ShiftCard__colour' style={{ backgroundColor: team.colour }} />

          <div className='ShiftCardTeam'>
            <p className='ShiftCardTeam__name'>{team.name}</p>
            <p className='ShiftCardTeam__details'>{shiftDetail.name}</p>
          </div>

          <div className='ShiftCardDetails'>
            <div className='ShiftCardDetails__row'>
              <div className="ShiftCardDetails__col">
                <p className='ShiftCardDetails__label'>Start</p>
                <p className='ShiftCardDetails__time'>{times.startTime}</p>
                <p className='ShiftCardDetails__time'>{times.startDate}</p>
              </div>
              <div className="ShiftCardDetails__col">
                <p className='ShiftCardDetails__label'>Finish</p>
                <p className='ShiftCardDetails__time'>{times.finishTime}</p>
                <p className='ShiftCardDetails__time'>{times.finishDate}</p>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return null;
  }
}

ShiftCard.propTypes = {
  schedule: PropTypes.object,
  shiftDetail: PropTypes.object,
  team: PropTypes.object,
};


export default ShiftCard;



// WEBPACK FOOTER //
// ./src/components/shared/shiftcard/main.jsx